//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */

(function() {
  angular.module('curalate')
        .service('LoggingService', [
          '$http',
          'PromiseService',
          'RestBaseUrl',
          function(
                $http,
                PromiseService,
                RestBaseUrl,
            ) {
            this.clientLogInfoAsync = function(message) {
              return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/log`, {
                message,
                level: 'info',
              }));
            };

            this.clientLogWarnAsync = function(message) {
              return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/log`, {
                message,
                level: 'warn',
              }));
            };

            this.clientLogErrorAsync = function(message) {
              return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/log`, {
                message,
                level: 'error',
              }));
            };
          },
        ]);
})();
